import IssuesPanel from './IssuesPanel';

export default IssuesPanel;
